module.exports = __webpack_public_path__ + "img/1.322913f8.jpg";